import React, { useEffect, useMemo, useRef } from "react";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import CustomDropdownCell from "../CustomDropdownCell";
import Swal from "sweetalert2";

const AssignWoModal = ({
    handleWOSelect,
    machine_id,
    currentSlot,
    dailyPlanData,
    isLoading,
}) => {
    const closeBtnRef = useRef(null);
    const {
        handleSubmit,
        control,
        reset,
        register,
        formState: { errors },
        watch,
    } = useForm();

    const wo = watch("wo");

    console.log(wo);

    const handleCloseModal = () => {
        if (closeBtnRef.current) {
            closeBtnRef.current?.click();
        }
    };

    let dateTemp = new Date(currentSlot);
    dateTemp.setHours(0, 0, 0, 0);

    const onSubmit = (data) => {
        // To-Do: With warninig if dependent work orders are not allocated.
        // if (true) {
        //     Swal.fire({
        //         title: "Are you sure?",
        //         text: "The selected work order has dependent work orders that are not yet allocated. Do you still want to proceed?",
        //         icon: "warning",
        //         showCancelButton: true,
        //     }).then((result) => {
        //         if (result.isConfirmed) {
        //             handleWOSelect(data.wo, data?.mould_size);
        //             handleCloseModal();
        //         }
        //     });
        // } else {
        //     handleWOSelect(data.wo, data?.mould_size);
        //     handleCloseModal();
        // }
        handleWOSelect(data.wo, data?.mould_size ?? 1);
        // handleWOSelect(data.wo, data?.mould_size?.value ?? 1);
        handleCloseModal();
    };

    useMemo(() => {
        reset({
            wo: null,
        });
    }, [currentSlot]);

    useEffect(() => {
        return () => {
            const backdrop = document.querySelector(".modal-backdrop");
            if (backdrop) {
                backdrop.remove();
                document.body.classList.remove("modal-open");
                document.body.style = "";
            }
        };
    }, []);

    return (
        <div
            className="modal fade m-0 p-0"
            tabIndex={-1}
            id={`add-wo-modal-${machine_id}`}
            aria-modal
        >
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <button
                        type="button"
                        className="close"
                        data-bs-dismiss="modal"
                        ref={closeBtnRef}
                    >
                        <em
                            className="icon ni ni-cross"
                            aria-hidden="true"
                        ></em>
                    </button>
                    <div className="modal-header">
                        <h5 className="modal-title">Create daily plan</h5>
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label
                                            htmlFor="wo"
                                            className="form-label"
                                        >
                                            Work Order
                                            <span className="fs-8 text-danger ms-1">
                                                *
                                            </span>
                                        </label>
                                        <Controller
                                            name="wo"
                                            control={control}
                                            rules={{
                                                required:
                                                    "Work order is required",
                                            }}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    options={
                                                        dailyPlanData?.data
                                                            ? [
                                                                  ...dailyPlanData?.data
                                                                      ?.filter(
                                                                          (
                                                                              item
                                                                          ) => {
                                                                              return (
                                                                                  new Date(
                                                                                      item?.work_order?.target_date
                                                                                  ) >=
                                                                                  new Date(
                                                                                      currentSlot
                                                                                  )
                                                                              );
                                                                          }
                                                                      )
                                                                      ?.map(
                                                                          (
                                                                              wo
                                                                          ) => ({
                                                                              ...wo,
                                                                              value: wo?.id,
                                                                              label: `${
                                                                                  wo
                                                                                      ?.work_order
                                                                                      ?.work_order_code
                                                                              }-${
                                                                                  wo
                                                                                      ?.item
                                                                                      ?.item_name
                                                                              }-${
                                                                                  wo?.work_order_req_quantity -
                                                                                  wo?.allotted_quantity_dailyplan
                                                                              }`,
                                                                          })
                                                                      ),
                                                              ].filter(
                                                                  (wo) =>
                                                                      wo?.cycles_to_run -
                                                                          wo?.cycles_allotted >
                                                                      0
                                                              )
                                                            : []
                                                    }
                                                    // components={{
                                                    //     Option: CustomDropdownCell,
                                                    // }}
                                                    // isOptionDisabled={(
                                                    //     option
                                                    // ) => option.isDisabled}
                                                    placeholder="Select a work order"
                                                    isLoading={isLoading}
                                                    isDisabled={isLoading}
                                                />
                                            )}
                                        />
                                        {errors.wo ? (
                                            <span className="text-danger mt-1">
                                                {errors.wo?.message}
                                            </span>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="col-md-12 mt-2">
                                    <label className="form-label">
                                        Per Cycle Output
                                        <span className="fs-8 text-danger ms-1">
                                            *
                                        </span>
                                    </label>
                                    <div className="form-control-wrap">
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="input-number-mould_size"
                                            placeholder="Enter mould size"
                                            {...register(`mould_size`, {
                                                valueAsNumber: true,
                                                required:
                                                    "Mould size is required",
                                                min: {
                                                    value: 1,
                                                    message:
                                                        "Minimum mould size is 1",
                                                },
                                            })}
                                        />
                                        {/* <Controller
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    options={
                                                        wo
                                                            ? wo?.mould_sizes?.map(
                                                                  (size) => ({
                                                                      value: size,
                                                                      label: size,
                                                                  })
                                                              )
                                                            : []
                                                    }
                                                    isLoading={isLoading}
                                                    isDisabled={isLoading}
                                                    isClearable={true}
                                                />
                                            )}
                                            rules={{
                                                required:
                                                    "Per cycle output is required",
                                            }}
                                            name="mould_size"
                                            control={control}
                                        /> */}
                                        {errors.mould_size ? (
                                            <span className="text-danger mt-1">
                                                {errors.mould_size?.message}
                                            </span>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer bg-light">
                            <button type="submit" className="btn btn-primary">
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AssignWoModal;
